export const Headcell40 = {
    minWidth: "1.5rem",
    width: "1.5rem",
};

export const Headcell80 = {
    minWidth: "4.1rem",
    width: "4.1rem",
};

export const Headcell100 = {
    minWidth: "4.87rem",
    width: "4.87rem",
};

export const Headcell130 = {
    minWidth: "5.6rem",
    width: "5.6rem",
};

export const Headcell150 = {
    minWidth: "6.8rem",
    width: "6.8rem",
};

export const Headcell170 = {
    minWidth: "7.8rem",
    width: "7.8rem",
};

export const Headcell200 = {
    minWidth: "9.5rem",
    width: "9.5rem",
};

export const Headcell250 = {
    minWidth: "10.2rem",
    width: "10.2rem",
};